export const generateLeftPaddingValue = (
	isMainNaviElement: boolean | undefined,
	itemLevel: number | undefined,
	isMobile: boolean,
) => {
	if (isMainNaviElement && isMobile) return 'pl-5';

	if (!itemLevel) return '';

	//TODO: refactor
	const leftPaddingValues: string[] = [
		`${isMobile ? 'pl-9' : ''}`,
		`${isMobile ? 'pl-14' : 'pl-8'}`,
		`${isMobile ? 'pl-20' : 'pl-16'}`,
		`${isMobile ? 'pl-24' : 'pl-20'}`,
		`${isMobile ? 'pl-28' : 'pl-24'}`,
		`${isMobile ? 'pl-32' : 'pl-28'}`,
		`${isMobile ? 'pl-36' : 'pl-32'}`,
		`${isMobile ? 'pl-40' : 'pl-36'}`,
		`${isMobile ? 'pl-44' : 'pl-40'}`,
		`${isMobile ? 'pl-48' : 'pl-44'}`,
	];

	return leftPaddingValues[itemLevel - 1];
};
